export interface AppConfig {
    BACKEND_URL: string;
    API_TIMEOUT: number;
    ENVIRONMENT: string;
}

declare global {
    interface Window {
        APP_CONFIG: AppConfig;
    }
}

export const getConfig = (): AppConfig => {
    if (process.env.NODE_ENV === 'development') {
        return {
            BACKEND_URL: process.env.REACT_APP_BACKEND_URL || 'http://localhost/api',
            API_TIMEOUT: 30000,
            ENVIRONMENT: 'development'
        };
    }

    return window.APP_CONFIG || {
        BACKEND_URL: 'https://api.edunexus.tech/api',
        API_TIMEOUT: 30000,
        ENVIRONMENT: 'production'
    };
};